/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { globe, logoLinkedin } from "ionicons/icons";

/* Components */
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";
import LinkButton from "src/components/shared/buttons/link-button/LinkButton";

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";

/* Stylesheet */
import styles from "./Footer.module.scss";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  const handleSocialLinks = (link: string) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.footer}>
      <IonGrid className={styles.grid_container}>
        <IonRow className={styles.content_row}>
          <IonCol className={`${styles.col}`} size="4">
            <div
              className={styles.call_to_action_container}
            >
              <div className={styles.question}>
                Do you want to <br />
                have access to the <br />
                <span>Insights</span>
              </div>
              <PrimaryButton
                type={"button"}
                label={"Contact Us"}
                ariaLabel={"Call to action"}
              />
            </div>
          </IonCol>
          <IonCol
            className={`${styles.col} ${styles.pages_col}`}
            size="8"
          >
            <IonCol>
              <div className={styles.label}>
                Getting started
              </div>
              <LinkButton label={"Introduction"} disabled />
              <LinkButton label={"Usage"} disabled />
            </IonCol>
            <IonCol>
              <div className={styles.label}>Platform</div>
              <LinkButton
                label={"Plans & Pricing"}
                disabled
              />
              <LinkButton
                label={"AI Data Processing"}
                disabled
              />
            </IonCol>
            <IonCol>
              <div className={styles.label}>About</div>
              <LinkButton label={"About us"} disabled />
              <LinkButton label={"Our Blog"} disabled />
              <LinkButton label={"Press"} disabled />
            </IonCol>
            <IonCol>
              <div className={styles.label}>Legal</div>
              <LinkButton
                label={"Terms of Service"}
                disabled
              />
              <LinkButton
                label={"Privacy Policy"}
                disabled
              />
              <LinkButton
                label={"Cookies Policy"}
                disabled
              />
              <LinkButton
                label={"Imprint"}
                path={Paths.IMPRINT}
              />
            </IonCol>
          </IonCol>
        </IonRow>
        <IonRow className={styles.subcontent_row}>
          <IonCol
            className={`${styles.col} ${styles.copyright_col}`}
          >
            <div className={styles.copyright}>
              &copy; {year} syndena GmbH - All rights
              reserved
            </div>
          </IonCol>
          <IonCol
            className={`${styles.col} ${styles.social_links_col}`}
          >
            <PrimaryFabButton
              ariaLabel={"Website"}
              icon={globe}
              onClick={() =>
                handleSocialLinks("https://www.syndena.com")
              }
              scssProps={{
                background: "transparent",
              }}
            />
            <PrimaryFabButton
              ariaLabel={"Website"}
              icon={logoLinkedin}
              onClick={() =>
                handleSocialLinks(
                  "https://www.linkedin.com/company/syndena/posts/?feedView=all"
                )
              }
              scssProps={{
                background: "transparent",
              }}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

export default Footer;
